<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>{{firearmAssetTypeName}} Assignment Approval</h2>
  <mat-dialog-content class="dialog-content">
    <div>
      <form [formGroup]="form">
        <div class="crud-item-section">
          <mat-form-field matTooltip="Comments" class="crud-item-input-verywide">
            <mat-label i18n="@@type.FirearmAssignment.comments">Comments</mat-label>
            <textarea matInput formControlName="comments" id="comments" [(ngModel)]="item.comments" maxlength="1000"
              placeholder="Comments">
          </textarea>
          </mat-form-field>
        </div>

        <div>
          <span class="crud-editor-info"><b>Requestor Comment:</b> {{data.firearmAssignment?.comments}}</span>
        </div>
        <div>
          <span *ngIf="data.firearmAssignment?.nextAction == 'LEAD_APPROVAL' || data.firearmAssignment?.nextAction == 'TRANSFER_BU_APPROVAL'" class="crud-editor-info"><b>BU WM Comment:</b>
            {{data.firearmAssignment?.buApprovalRejectionReason}}</span>
        </div>
        <div>
          <span *ngIf="data.firearmAssignment?.nextAction == 'LEAD_APPROVAL' && data.firearmAssignment?.transferAsset != null" class="crud-editor-info"><b>Transfer BU WM Comment:</b>
            {{data.firearmAssignment?.transferAsset?.approvalRejectionComment}}</span>
        </div>
      </form>
    </div>


  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button mat-raised-button color="primary" [disabled]="!isApproveRejectEnabled()"
      (click)="approveFirearmAssignment()">Approve</button>
    <button mat-raised-button color="accent2" [disabled]="!isApproveRejectEnabled()"
      (click)="rejectFirearmAssignment()">Reject</button>
    <button mat-raised-button color="accent" (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
  <div class="crud-editor-error-list" *ngIf="getFormErrorList().length > 0">
    <br>
    <h2>Errors:</h2>
    <div *ngFor="let error of getFormErrorList()" class="crud-editor-err-msg">{{error}}</div>
  </div>
</div>